module.exports = __webpack_public_path__ + "static/media/Pdf.f3bed091.svg";